export default function isGreaterThanDate(firstDate: Date, secondDate: Date) {
  const d1 = new Date(firstDate);
  d1.setHours(0, 0, 0, 0);
  const d2 = new Date(secondDate);
  d2.setHours(0, 0, 0, 0);
  return d1 > d2;
}
